import { Outlet } from "react-router";

import { Box, Stack } from "@mui/material";

import { useTranslation } from "@/translations";

import { MaintenanceBanner } from "../maintenance-banner/MaintenanceBanner";
import PageContentLoadingIndicator from "../page-content-loading-indicator/PageContentLoadingIndicator";
import { MAIN_CONTENT_PADDING_X } from "./Layout.constants";
import { DropZonePanel } from "./components/dropzone/DropZonePanel";
import { DocumentDndProvider } from "./components/dropzone/dnd/DocumentDndProvider";
import { Header } from "./components/header/Header";
import { LayoutNavigation } from "./components/layout-navigation/LayoutNavigation";
import { LayoutContext } from "./context/LayoutContext";
import { useLayout } from "./hooks/useLayout";

export function Layout() {
  const { t } = useTranslation();
  const { isNavigationCollapsed, handleNavigationCollapse, navigationWidth, isDropZoneOpen, toggleDropZone } =
    useLayout();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <MaintenanceBanner />
      <Box sx={{ display: "flex", flexGrow: 1, minHeight: 0 }}>
        <LayoutNavigation
          isNavigationCollapsed={isNavigationCollapsed}
          onToggleNavigationCollapse={handleNavigationCollapse}
          navigationWidth={navigationWidth}
          isDropZoneOpen={isDropZoneOpen}
          onDropZoneToggle={toggleDropZone}
        />
        <DocumentDndProvider>
          {isDropZoneOpen && <DropZonePanel isOpen={isDropZoneOpen} onClose={toggleDropZone} />}
          <Stack flexGrow={1} minWidth={0}>
            <Header />
            <Stack
              component={"main"}
              // With the document unable to scroll, the content area is the fallback scroller:
              // minHeight:0 lets it shrink below its content, auto keeps a tall page reachable.
              sx={{ flexGrow: 1, minHeight: 0, px: MAIN_CONTENT_PADDING_X, py: 0, overflow: "auto" }}
              aria-label={t("layout.header.pageContent")}
            >
              <LayoutContext.Provider value={{ isDropZoneOpen }}>
                <PageContentLoadingIndicator navigationWidth={navigationWidth}>
                  <Outlet />
                </PageContentLoadingIndicator>
              </LayoutContext.Provider>
            </Stack>
          </Stack>
        </DocumentDndProvider>
      </Box>
    </Box>
  );
}
